import { Container, GridProps } from "@mui/material";
import {
  SmartCheckbox,
  SmartDateTimePicker,
  SmartForm,
  SmartTextField,
} from "@nodeon/react-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { AtonUnit } from "~/api/GeneratedApi";

interface FormData {
  atonNumber: number;
  name: string;
  hasLighting: boolean;
  seadaticsRemoteMonitoring: boolean;
  subType: string;
  state: string;
  owner: string;
  type: string;
  navigationType: string;
  structureType: string;
  functionalState: string;
  facadeLighting: boolean;
  updateTimestamp: Date;
}

interface Props {
  atonData: AtonUnit;
  small?: boolean;
}

const AtoNDetailsTab = ({ atonData, small }: Props): JSX.Element => {
  const { t } = useTranslation("aton");
  const disabled = true;

  const fieldSize: GridProps = React.useMemo(
    () => (small ? { xs: 6 } : { xs: 6, lg: 4 }),
    [small],
  );

  return (
    <Container>
      <SmartForm<FormData, null, true>
        onSubmit={() => null}
        formProps={{
          defaultValues: atonData as unknown as FormData,
        }}
      >
        <SmartTextField<FormData>
          fullWidth
          disabled={disabled}
          name="atonNumber"
          label={t("atonNumber")}
          gridProps={fieldSize}
        />
        <SmartTextField<FormData>
          fullWidth
          disabled={disabled}
          name="name"
          label={t("name")}
          gridProps={fieldSize}
        />
        <SmartTextField<FormData>
          fullWidth
          disabled={disabled}
          name="state"
          label={t("state")}
          gridProps={fieldSize}
        />
        <SmartTextField<FormData>
          fullWidth
          disabled={disabled}
          name="type"
          label={t("type")}
          gridProps={fieldSize}
        />
        <SmartTextField<FormData>
          fullWidth
          disabled={disabled}
          name="subType"
          label={t("subType")}
          gridProps={fieldSize}
        />
        <SmartTextField<FormData>
          fullWidth
          disabled={disabled}
          name="navigationType"
          label={t("navigationType")}
          gridProps={fieldSize}
        />
        <SmartTextField<FormData>
          fullWidth
          disabled={disabled}
          name="functionalState"
          label={t("functionalState")}
          gridProps={fieldSize}
        />
        <SmartTextField<FormData>
          fullWidth
          disabled={disabled}
          name="structureType"
          label={t("structureType")}
          gridProps={fieldSize}
        />
        <SmartTextField<FormData>
          fullWidth
          disabled={disabled}
          name="owner"
          label={t("owner")}
          gridProps={fieldSize}
        />
        <SmartCheckbox<FormData>
          name="hasLighting"
          label={t("lighting")}
          disabled={disabled}
        />
        <SmartCheckbox<FormData>
          name="seadaticsRemoteMonitoring"
          label={t("lighting")}
          disabled={disabled}
        />
        <SmartCheckbox<FormData>
          name="facadeLighting"
          label={t("facadeLighting")}
          disabled={disabled}
        />
        <SmartDateTimePicker<FormData>
          textfieldProps={{ fullWidth: true }}
          disabled={disabled}
          name="updateTimestamp"
          label={t("updateTimestamp")}
          gridProps={fieldSize}
        />
      </SmartForm>
    </Container>
  );
};

export default AtoNDetailsTab;
